import { render, staticRenderFns } from "./StoryEditor.vue?vue&type=template&id=1bc0448f&"
import script from "./StoryEditor.vue?vue&type=script&lang=js&"
export * from "./StoryEditor.vue?vue&type=script&lang=js&"
import style0 from "./StoryEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports